(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const select = root.querySelector('[data-inquiry-type]');
    const options = [...select.options];
    const existingOrder = root.querySelector('#DoorExistingOrder');
    const orderNumber = root.querySelector('#DoorOrder');
    const form = root.querySelector('form');
    const result = root.querySelector('[data-form-result]');
    const storageKey = 'sg-contact-draft:' + location.pathname;
    const fields = [...root.querySelectorAll('[data-for] input, [data-for] select')];
    const clearDraft = () => { try { sessionStorage.removeItem(storageKey); } catch (_) { /* Storage may be blocked. */ } };
    // Prune stale drafts on every visit, including fresh and CAPTCHA-return pages.
    // Keep a recent draft so reloading a return can still recover a native error.
    try {
      const draft = JSON.parse(sessionStorage.getItem(storageKey));
      if (draft && (!Number.isFinite(draft.savedAt) || Date.now() - draft.savedAt >= 30 * 60 * 1000 ||
        draft.savedAt > Date.now())) clearDraft();
    } catch (_) { clearDraft(); }
    let returnNotice;
    // Shopify can return CAPTCHA answers in the URL without setting form.errors.
    const returned = new URLSearchParams(location.search);
    const returnedType = returned.get('contact[Inquiry type]');
    const challengeReturn = returned.get('form_type') === 'contact' && location.hash === '#ContactDoorsForm' &&
      options.some(option => option.value === returnedType);
    let restored = false;
    if (result.dataset.success === 'true') clearDraft();
    else if (challengeReturn && result.dataset.hasErrors !== 'true') {
      returnNotice = root.querySelector('[data-return-notice]');
      returnNotice.hidden = false;
      select.value = returnedType;
      fields.forEach(field => {
        if (returned.has(field.name)) field.value = returned.get(field.name);
      });
      restored = true;
    } else if (result.dataset.hasErrors === 'true') {
      try {
        const draft = JSON.parse(sessionStorage.getItem(storageKey));
        if (draft && Date.now() - draft.savedAt < 30 * 60 * 1000 && options.some(option => option.value === draft.type)) {
          select.value = draft.type;
          fields.forEach(field => {
            if (typeof draft.fields?.[field.name] === 'string') field.value = draft.fields[field.name];
          });
          restored = true;
        } else clearDraft();
      } catch (_) { clearDraft(); }
    }
    form.addEventListener('submit', () => {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({ savedAt: Date.now(), type: select.value,
          fields: Object.fromEntries(fields.filter(field => !field.disabled).map(field => [field.name, field.value])) }));
      } catch (_) { /* Native submission must remain available without storage. */ }
    });
    const apply = () => {
      const route = select.selectedOptions[0].dataset.route;
      root.querySelectorAll('[data-for]').forEach(group => {
        const show = group.dataset.for.split(' ').includes(route);
        group.hidden = !show;
        group.disabled = !show;
        group.querySelectorAll('input,select,textarea').forEach(input => input.disabled = !show);
      });
      root.querySelectorAll('[data-door]').forEach(door => {
        if (door.dataset.door === route) door.setAttribute('aria-current', 'true');
        else door.removeAttribute('aria-current');
      });
      root.querySelector('[data-club-name]').required = route === 'club-merchandise';
      existingOrder.required = route === 'general';
      const needsOrder = route === 'general' && existingOrder.value === 'Yes';
      root.querySelector('[data-order-details]').hidden = !needsOrder;
      orderNumber.disabled = !needsOrder;
      orderNumber.required = needsOrder;
    };
    const fromHash = () => {
      const option = options.find(option => '#' + option.dataset.route === location.hash);
      if (option) select.value = option.value;
      apply();
    };
    root.querySelectorAll('[data-door]').forEach(door => door.addEventListener('click', event => {
      event.preventDefault();
      select.value = options.find(option => option.dataset.route === door.dataset.door).value;
      history.replaceState(null, '', door.hash);
      apply();
      select.focus();
      select.scrollIntoView({block: 'center', behavior: 'instant'});
    }));
    select.addEventListener('change', () => {
      history.replaceState(null, '', '#' + select.selectedOptions[0].dataset.route);
      apply();
    });
    window.addEventListener('hashchange', fromHash);
    existingOrder.addEventListener('change', apply);
    if (restored) apply();
    else fromHash();
    // Focus only after restored fieldsets have their final visibility and requirements.
    if (returnNotice) {
      // Track visitor interaction, not the browser's initial fragment scroll.
      let interacted = false;
      const cancelFocus = () => { interacted = true; };
      const scrollKey = event => {
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) cancelFocus();
      };
      const inputs = ['wheel', 'touchmove', 'pointerdown'];
      inputs.forEach(type => window.addEventListener(type, cancelFocus, { passive: true }));
      window.addEventListener('keydown', scrollKey);
      const focusNotice = () => requestAnimationFrame(() => {
        inputs.forEach(type => window.removeEventListener(type, cancelFocus));
        window.removeEventListener('keydown', scrollKey);
        if (!interacted && (document.activeElement === document.body || document.activeElement === form)) {
          returnNotice.focus({ preventScroll: false });
        }
      });
      if (document.readyState === 'complete') focusNotice();
      else window.addEventListener('load', focusNotice, { once: true });
    }
  }
  document.querySelectorAll('[data-contact-doors]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-contact-doors]').forEach(init));
})();
